var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from "react";
import { inject, observer } from "mobx-react";
import { ThemeBusiness } from "@business/common/theme";
import { withRouter } from "react-router-dom";
import { ShareBusiness } from "@business/common/share";
import { combine } from "fe-toolkit";
import { allowAnonymousList } from "@router/layout/config";
var Theme = /** @class */ (function (_super) {
    __extends(Theme, _super);
    function Theme() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Theme.prototype.componentDidMount = function () {
        var isIgnore = allowAnonymousList.some(function (x) { return location.href.toLowerCase().includes(x.path.toLowerCase()); });
        !isIgnore && this.props.getClientCode();
        this.addClass();
    };
    Theme.prototype.addClass = function () {
        if (this.props.clientCode) {
            document.body.className = this.props.clientCode;
        }
    };
    Theme.prototype.componentDidUpdate = function () {
        this.addClass();
    };
    Theme.prototype.render = function () {
        return this.props.children;
    };
    Theme = __decorate([
        inject(combine(ThemeBusiness, ShareBusiness)),
        observer
    ], Theme);
    return Theme;
}(Component));
export { Theme };
export default withRouter(Theme);
